(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-quote-carousel"] && !Shopify.designMode) return;
  try {
    
  class HwQuoteCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hw-track]');
      this.dotsContainer = this.querySelector('[data-hw-dots]');
      this.dots = Array.from(this.querySelectorAll('[data-hw-dot]'));
      if (!this.track || this.dots.length === 0) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.hwDot);
          const card = this.track.children[index];
          if (card) {
            this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          }
        });
      });

      // Live sync: update dots every frame while scrolling - no debounce,
      // so the active dot moves with the swipe instead of after it.
      this.track.addEventListener(
        'scroll',
        () => {
          if (this._raf) return;
          this._raf = window.requestAnimationFrame(() => {
            this._raf = null;
            this.updateDots();
          });
        },
        { passive: true }
      );

      // Hide dots entirely when every card already fits in view (desktop).
      this.checkOverflow();
      this._resizeObserver = new ResizeObserver(() => this.checkOverflow());
      this._resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }

    checkOverflow() {
      if (!this.dotsContainer) return;
      const fits = this.track.scrollWidth <= this.track.clientWidth + 1;
      this.dotsContainer.toggleAttribute('hidden', fits);
    }

    updateDots() {
      const cards = Array.from(this.track.children);
      if (cards.length === 0) return;
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let activeIndex = 0;
      let best = Infinity;
      cards.forEach((card, i) => {
        const cardCenter = card.offsetLeft - this.track.offsetLeft + card.offsetWidth / 2;
        const d = Math.abs(cardCenter - center);
        if (d < best) {
          best = d;
          activeIndex = i;
        }
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
    }
  }

  if (!customElements.get('hw-quote-carousel')) {
    customElements.define('hw-quote-carousel', HwQuoteCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-reviews"] && !Shopify.designMode) return;
  try {
    
  class HwReviewsList extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-hw-load-more]');
      if (this.button) {
        this.button.addEventListener('click', () => {
          this.querySelectorAll('.hw-reviews__card[hidden]').forEach((item) => item.removeAttribute('hidden'));
          const more = this.querySelector('.hw-reviews__more');
          if (more) more.remove();
        });
      }
      this.setupLightbox();
    }

    setupLightbox() {
      const root = this.closest('.hw-reviews');
      if (!root) return;
      const lb = root.querySelector('[data-hw-lb]');
      if (!lb || typeof lb.showModal !== 'function') return;

      const inner = lb.querySelector('[data-hw-lb-inner]');
      const cards = Array.from(this.querySelectorAll('[data-hw-review]'));
      if (!cards.length) return;
      let current = 0;
      let opener = null;

      const render = (i) => {
        const card = cards[i];
        if (!card) return;
        const photo = card.querySelector('.hw-reviews__photo img');
        const parts = [];
        if (photo) {
          parts.push('<img src="' + photo.currentSrc + '" alt="' + (photo.alt || '') + '">');
        }
        const top = card.querySelector('.hw-reviews__card-top');
        const title = card.querySelector('.hw-reviews__title');
        const body = card.querySelector('.hw-reviews__body');
        const author = card.querySelector('.hw-reviews__author');
        parts.push(
          '<div class="hw-reviews__lb-body">' +
            (top ? top.outerHTML : '') +
            (title ? title.outerHTML : '') +
            (body ? body.outerHTML : '') +
            (author ? author.outerHTML : '') +
          '</div>'
        );
        inner.className = 'hw-reviews__lb-inner' + (photo ? ' hw-reviews__lb-inner--media' : '');
        inner.innerHTML = parts.join('');
        inner.scrollTop = 0;
        current = i;
      };

      const open = (i, el) => {
        opener = el || opener;
        render(i);
        if (!lb.open) lb.showModal();
        document.documentElement.style.overflow = 'hidden';
        const close = lb.querySelector('[data-hw-lb-close]');
        if (close) close.focus();
      };

      const step = (d) => open((current + d + cards.length) % cards.length);

      cards.forEach((card, i) => {
        card.addEventListener('click', () => open(i, card));
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open(i, card);
          }
        });
      });

      lb.querySelector('[data-hw-lb-close]').addEventListener('click', () => lb.close());
      lb.querySelector('[data-hw-lb-next]').addEventListener('click', () => step(1));
      lb.querySelector('[data-hw-lb-prev]').addEventListener('click', () => step(-1));
      lb.addEventListener('click', (e) => {
        if (e.target === lb || e.target.hasAttribute('data-hw-lb-panel')) lb.close();
      });
      lb.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
        if (opener) opener.focus();
      });
      lb.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') step(1);
        if (e.key === 'ArrowLeft') step(-1);
      });
    }
  }

  if (!customElements.get('hw-reviews-list')) {
    customElements.define('hw-reviews-list', HwReviewsList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-visual"] && !Shopify.designMode) return;
  try {
    
  // Below-the-fold video costs nothing until it is nearly on screen: sources
  // carry data-src and are only promoted to src when the element approaches
  // the viewport. Falls back to loading immediately if IntersectionObserver
  // is unavailable.
  (function () {
    function activate(video) {
      if (video.dataset.hwLoaded === 'true') return;
      video.dataset.hwLoaded = 'true';
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        if (source.dataset.src) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        }
      });
      video.load();
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          /* Autoplay refused (e.g. reduced-data mode). The poster stays. */
        });
      }
    }

    function init(root) {
      var videos = (root || document).querySelectorAll('video[data-hw-lazy-video]');
      if (!videos.length) return;

      if (!('IntersectionObserver' in window)) {
        videos.forEach(activate);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              activate(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '400px 0px' }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    // Re-bind when the theme editor re-renders this section.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
